// Localized route configuration
export const routes = {
  home: {
    bs: '/',
    en: '/en',
    tr: '/tr'
  },
  about: {
    bs: '/about',
    en: '/en/about',
    tr: '/tr/about'
  },
  services: {
    bs: '/services',
    en: '/en/services',
    tr: '/tr/services'
  },
  blog: {
    bs: '/blog',
    en: '/en/blog',
    tr: '/tr/blog'
  },
  contact: {
    bs: '/contact',
    en: '/en/contact',
    tr: '/tr/contact'
  }
} as const;

export type RouteKey = keyof typeof routes;
export type Locale = 'bs' | 'en' | 'tr';

// Get localized route
export function getLocalizedRoute(route: RouteKey, locale: Locale): string {
  return routes[route][locale];
}

// Get current page from pathname
export function getCurrentPage(pathname: string): RouteKey | null {
  const cleanPath = pathname.replace(/\/$/, '') || '/';

  for (const [page, locales] of Object.entries(routes)) {
    for (const [, path] of Object.entries(locales)) {
      if (cleanPath === path || cleanPath === path.replace(/\/$/, '')) {
        return page as RouteKey;
      }
    }
  }

  return null;
}

// Get current locale from pathname
export function getCurrentLocale(pathname: string): Locale {
  if (pathname.startsWith('/en')) return 'en';
  if (pathname.startsWith('/tr')) return 'tr';
  return 'bs';
}
